import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { LinkType } from '../../../../../containers/Editor/constants';
import RadioBox, { RadioBoxTheme } from '../../../../Form/RadioBox';
import { RadioButtons } from '../styles';

interface LinkTypeToggleProps {
	canAddPopupAction: boolean;
	type: LinkType;
	onChange: (type: string) => void;
}

const getLabel = (type: LinkType): string => {
	switch (type) {
		case LinkType.goToPage:
			return 'messages.goto_page';
		case LinkType.goToChapterId:
			return 'messages.goto_page_id';
		case LinkType.mailto:
			return 'messages.email';
		case LinkType.popup:
			return 'messages.popup_label';
		case LinkType.url:
		default:
			return 'messages.url';
	}
};

const LinkTypeToggle = ({ canAddPopupAction, type, onChange }: LinkTypeToggleProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = e.target;
		onChange(value);
	};

	const linkTypes = [LinkType.url, LinkType.mailto, LinkType.goToPage, LinkType.goToChapterId];
	if (canAddPopupAction) {
		linkTypes.push(LinkType.popup);
	}

	return (
		<RadioButtons>
			{linkTypes.map(linkType => (
				<RadioBox
					key={linkType}
					name="linkType"
					label={<Translate value={getLabel(linkType)} />}
					value={linkType}
					isChecked={type === linkType}
					onChange={handleChange}
					theme={RadioBoxTheme.DARK}
				/>
			))}
		</RadioButtons>
	);
};

export default LinkTypeToggle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/LinkPanel/LinkTypeToggle/index.tsx